import React from 'react';

function FontSize({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <path d="M3.35621304,14.8140631 L2.24364023,17.7921445 L2.24364023,17.7921445 C2.24339804,17.7928431 2.24376808,17.7936058 2.24446674,17.793848 C2.24515441,17.7940864 2.24590656,17.7937318 2.24616023,17.7930496 L2.62021071,16.7870975 L6.32115099,6.83397904 C6.417393,6.57515074 6.70523435,6.44334851 6.96406265,6.53959051 C7.09870717,6.58965636 7.2053137,6.69521504 7.25670705,6.82935847 L11.4434123,17.7572114 C11.4441,17.7590063 11.4461125,17.759904 11.4479075,17.7592163 C11.4496471,17.7585498 11.4505534,17.7566317 11.4499638,17.7548646 L10.6164626,15.5621829" />
      <path d="M3.92307692,13.9993652 L10.0769231,13.9993652" />
      <path d="M15.304116,14.625 L20.4615385,14.625" />
      <path d="M15.4486633,14.8137892 L14.3077496,17.8576538 L14.3077496,17.8576538 C14.3075544,17.8582168 14.3078526,17.8588314 14.3084156,17.8590266 C14.3089697,17.8592187 14.3095758,17.858933 14.3097802,17.8583832 L14.6111978,17.0477662 L17.5038477,9.26842258 C17.6000897,9.00959428 17.887931,8.87779205 18.1467593,8.97403405 C18.2814038,9.0240999 18.3880104,9.12965858 18.4394037,9.26380201 L21.721116,17.8295041 C21.7216702,17.8309505 21.723292,17.8316738 21.7247384,17.8311196 C21.7261402,17.8305826 21.7268705,17.8290369 21.7263953,17.8276129 L20.7441699,15.2863628" />
    </svg>
  );
}

export default FontSize;
